import { filter, identity, map, mapObjIndexed, pipe } from 'ramda';
import validationMethods from '@theme/js/utils/Validation/validationMethods'; // TotalCasino changes

const extractErrorFromFieldValidator = (compiledList, fieldName) =>
    (value, props) => {
        for (let i = 0; i < compiledList.length; i++) {
            const error = compiledList[i](value, props, fieldName);
            if (error) {
                return error;
            }
        }

        return null;
    };

export const compileValidation = (validationConfig, methods = validationMethods) =>
    pipe(
        mapObjIndexed(
            pipe(
                map((rule) => {
                    if (!rule) {
                        return null;
                    }

                    if (typeof rule === 'string') {
                        const method = methods[rule];
                        return method && method();
                    }

                    const { type, ...options } = rule;
                    const method = methods[type];

                    if (!method) {
                        return null;
                    }

                    return method(options);
                }),
                filter(Boolean)
            )
        ),
        mapObjIndexed(extractErrorFromFieldValidator)
    )(validationConfig);

// At the moment changing translations doesn't work until next `validate()` call.
const getValidateFn = ({
    validationConfig,
    t = identity,
    compileConfig = compileValidation
}) => {
    const compiledValidationConfig = compileConfig(validationConfig);

    return async (values) => {
        const validatedValues = mapObjIndexed(
            (validateField, fieldName) => validateField(values[fieldName], values),
            compiledValidationConfig
        );
        const fieldNames = Object.keys(validatedValues);
        const maybeErrors = Object.values(validatedValues);

        const results = await Promise.all(maybeErrors);

        const errors = results.reduce((memo, error, index) => {
            if (error == null) {
                return memo;
            }

            const fieldName = fieldNames[index];
            memo[fieldName] = error;
            return memo;
        }, {});

        return Object.keys(errors).length > 0
            ? mapObjIndexed(params => t(...params), errors)
            : null;
    };
};

export default getValidateFn;
